import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  selectAuth,
  setPrivileges,
  setToken,
} from "../../../../redux/features/auth/auth-slice";
import { resetBillingSpaceFilter } from "../../../../redux/features/billing-space-filter/billing-space-filter-slice";
import {
  resetProfile,
  selectProfile,
} from "../../../../redux/features/user/user-slice";
import { UserRole } from "../../enums/user-roles";
import { AppRoute } from "../../interfaces/app-routes";
import IPageInfo from "../../interfaces/page-info";
import FeedbackModal from "../../shared-components/feedback-modal/feedback-modal";
import LogoutModal from "../../shared-components/logout-modal/logout-modal";
import MenuItem from "../../shared-components/sidebar/components/menu-item/menu-item";

interface IProps {
  collapsed?: boolean;
  closeMobileNav?: () => void;
  routes: IPageInfo[];
  logos: string[];
}

const AppMenuContent = (props: IProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { collapsed = false, closeMobileNav, routes, logos } = props;
  const [showLogout, setShowLogout] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const profile = useSelector(selectProfile);
  const auth = useSelector(selectAuth);

  const logout = () => {
    sessionStorage.clear();
    localStorage.clear();
    dispatch(setToken(""));
    dispatch(resetProfile());
    dispatch(setPrivileges([]));
    dispatch(resetBillingSpaceFilter());

    if (routes) {
      if (
        profile?.role === UserRole.ROLE_ADMIN ||
        profile?.role === UserRole.ROLE_SOLAR_DASHBOARD_ADMIN
      ) {
        navigate(AppRoute.ADMIN_LOGIN);
      } else {
        navigate(AppRoute.PUBLIC_CALCULATE_ENERGY);
      }
    }
  };

  return (
    <Container className="h-100" style={{ zIndex: 9999 }}>
      <div className="h-100 d-flex flex-column justify-content-between py-4 bg-white">
        <Row>
          <Col>
            <Row>
              <Col xs={12}>
                {collapsed ? (
                  <img
                    src={logos[1]}
                    alt="Chloride Exide Logo"
                    className="d-block mx-auto mb-3"
                    width="45px"
                  />
                ) : (
                  <img
                    src={logos[0]}
                    alt="Chloride Exide Logo"
                    className="d-block mx-auto mb-3"
                  />
                )}
              </Col>
            </Row>
            <Row className="mt-4">
              {routes.map((sc) => {
                return sc?.subRoutes
                  ?.filter(
                    (item) =>
                      item.showOnDrawer &&
                      (item.privilege
                        ? auth.privileges.includes(item.privilege)
                        : true)
                  )
                  .map((subRoute) => (
                    <Col
                      xs={12}
                      key={subRoute.path}
                      className="py-3 text-center d-flex justify-content-center"
                    >
                      <MenuItem
                        active={pathname.includes(subRoute.path)}
                        collapsed={props.collapsed}
                        icon={subRoute.icon}
                        to={subRoute.path}
                        text={subRoute.name}
                        onClick={closeMobileNav && closeMobileNav}
                        enableRoute={subRoute.enableRoute}
                        bgColor={subRoute.bgColor}
                        bgColorIcon={subRoute.bgColorIcon}
                      />
                    </Col>
                  ));
              })}
            </Row>
          </Col>
        </Row>
        <Row className="justify-content-center py-3">
          <Col xs="auto">
            {/* {profile?.role === UserRole.ROLE_USER && (
              <FeedbackButton
                collapsed={props.collapsed}
                setShowFeedback={() => setShowFeedback(true)}
              />
            )} */}
            <Row className="mt-1">
              <Col>
                <MenuItem
                  active={false}
                  collapsed={props.collapsed}
                  icon="logout"
                  onClick={() => setShowLogout(true)}
                  text="Logout"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <LogoutModal
        show={showLogout}
        onCancel={() => setShowLogout(false)}
        onClose={() => setShowLogout(false)}
        onConfirm={() => {
          setShowLogout(false);
          logout();
        }}
      />
      <FeedbackModal
        show={showFeedback}
        onCancel={() => setShowFeedback(false)}
        onClose={() => setShowFeedback(false)}
        onConfirm={() => {
          setShowFeedback(false);
        }}
      />
    </Container>
  );
};

export default AppMenuContent;
